export default __webpack_public_path__ + "static/media/icon1.839ad7b0.png";